import { ArrowRight, Linkedin } from "lucide-react";
import { LINKEDIN_URL } from "./data";

export function FooterSection({ onBook }) {
  return (
    <footer>
      <div className="container footer-inner">
        <div className="brand footer-brand"><img className="brand-logo" data-testid="footer-logo" src="/logo-white.png" alt="Dr. Sreeniketh Reddy — Urologist, Andrologist and Robotic Surgeon" /></div>
        <div>
          <span>Ready when you are.</span>
          <a data-testid="footer-appointment-link" onClick={onBook}>Request an appointment <ArrowRight size={15} /></a>
          <a className="footer-linkedin" data-testid="footer-profile-link" href="/dr-sreeniketh-reddy/"><ArrowRight size={14} /> Doctor profile</a>
          <a className="footer-linkedin" data-testid="footer-linkedin-link" href={LINKEDIN_URL} target="_blank" rel="noreferrer"><Linkedin size={14} /> Connect on LinkedIn</a>
        </div>
        <small className="footer-areas" data-testid="footer-areas">Serving Hitec City · Gachibowli · Madhapur · Kondapur · Financial District · Tolichowki · Hyderabad</small>
        <small className="disclaimer">Disclaimer: The information on this website is for general education only and is not medical advice. Always meet a doctor for advice about your own health.</small>
      </div>
    </footer>
  );
}
